<div class="w-full" mat-dialog-title>
  <div class="flex items-center justify-between gap-4">
    <h2 class="text-lg font-medium" data-test-id="outreach-email-dialog-title">
      Send email
      @if (emailData.expertName) {
        — {{ emailData.expertName }}
      }
    </h2>
    <button mat-icon-button type="button" aria-label="Close dialog" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content>
  <app-outreach-email
    [emailData]="emailData"
    [showCancel]="true"
    (emailSent)="onEmailSent($event)"
    (cancelled)="close()"
  />
</mat-dialog-content>
